//@ts-nocheck
import React from 'react'
import styles from './preloader.module.scss'
import { Preloader, BallTriangle } from 'react-preloader-icon'
import logo from '../../../assets/logo.png'

const MyPreloader = ({ size = 'medium' }) => {
  return (
    <div className={styles.container}>
      <img src={logo} className={styles.loader} data-size={size} />
    </div>
  )
}

export default MyPreloader
